export function pricePresentation(price, prices = []) {
    const index = prices.indexOf(price);
    const lowest = index >= 0 && index === prices.length - 1;
    return {
        deal: prices.length > 1 && (lowest || price < 2000),
        yellow: (prices.length > 1 && lowest) || price < 2000,
        primary: index === 2,
    };
}

export function remainingCapacity(candidates, attributed = null) {
    const remaining = (slot) => slot.bookable === true ? Math.max(0, slot.max_seats - slot.booked_seats) : 0;
    // For an unavailable time, display a single public arena's effective capacity.
    // Never add together capacities of arenas that cannot host the same reservation.
    const slot = attributed ?? [...(candidates ?? [])]
        .filter(s => s.arena_public !== false)
        .sort((a, b) => remaining(b) - remaining(a) || b.max_seats - a.max_seats)[0];
    return { remaining: slot ? remaining(slot) : 0, capacity: slot?.max_seats ?? 0 };
}
